/**
 * Sets a cookie with the specified name, value, and number of days until expiration.
 * @param {string} name - The name of the cookie to set.
 * @param {string} value - The value to store in the cookie.
 * @param {number} days - The number of days until the cookie expires.
 */
export function setCookie(name: string, value: string, days: number): void {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/; domain=.credwise.com; Secure; SameSite=Lax`;
}
